<template>
    <LoaderAnimation v-if="ajaxLoading"></LoaderAnimation>
    <div class="row availability_check" v-if="injectedBookingArrivalDate">
        <input type="hidden" v-model="injectedBookingAccTypeId" />
        <input type="hidden" v-model="injectedBookingLang" />
        <div class="accom_date">
            <label for="injectedBookingArrivalDateID">{{
                $t("Date from")
            }}</label>
            <input
                :disabled="true"
                type="hidden"
                v-model="injectedBookingArrivalDate"
                id="injectedBookingArrivalDateID"
            />
            <input
                :disabled="true"
                type="text"
                :value="ISO2Uk(injectedBookingArrivalDate)"
                id="injectedBookingArrivalDateID"
            />
        </div>
        <div class="accom_date">
            <label for="injectedBookingDepartureDateID">{{
                $t("Date from")
            }}</label>
            <input
                :disabled="true"
                type="hidden"
                v-model="injectedBookingDepartureDate"
                id="injectedBookingDepartureDateID"
            />
            <input
                :disabled="true"
                type="text"
                :value="ISO2Uk(injectedBookingDepartureDate)"
                id="injectedBookingDepartureDateID"
            />
        </div>
        <div class="accom_btn">
            <label style="display:block; opacity:0">{{
                $t("Change dates/accommodation")
            }}</label>
            <a href="#" class="button blue" @click.prevent="removeInjected">{{
                $t("Change dates/accommodation")
            }}</a>
        </div>
        <pre></pre>
        <div style="width:100%">
            <label style="display:block; opacity:0">{{ $t("Continue") }}</label>
            <span
                v-for="(accomTypeList,
                accomTypeName,
                index) in getLoadedAvailability"
                :key="index"
            >
                <span
                    v-for="(value, accomID, index2) in accomTypeList"
                    :key="index2"
                >
                    <p
                        style="text-align:center"
                        v-if="
                            (value.isByo == 'true' ? 'b' : 'a') +
                                extractId(accomID) ==
                                injectedBookingAccTypeId
                        "
                    >
                        <a
                            href="#"
                            class="button blue"
                            @click.prevent="
                                setAccommodationType(
                                    extractId(accomID),
                                    value.isByo,
                                    value.price,
                                    value.accommodation,
                                    value.drg,
                                    value.altPrice
                                )
                            "
                            >{{ $t("Book") }} "{{ value.accommodation }}"
                            {{ $t("for") }} {{ getCurrency.symbol
                            }}{{ value.price }}</a
                        >
                    </p>
                </span>
            </span>
        </div>
    </div>

    <div class="row availability_check" v-if="!injectedBookingArrivalDate">
        <div class="accom_date">
            <label for="BookingBookedArrivalDate">{{ $t("Date from") }}</label>
            <select
                @change="clearAccommodations"
                v-model="selectedArrivalDate"
                class="selectBoxIt inputbtn btndefault btnblock styled-select"
                id="BookingBookedArrivalDate"
            >
                <option value="">{{ $t("Select arrival date") }}</option>
                <option
                    v-for="(dates_obj, date1) in getLoadedDates"
                    :value="date1"
                    :key="date1"
                >
                    {{ $t(weekDay(date1)) }}, {{ ISO2Uk(date1) }}
                </option>
            </select>
        </div>
        <div class="accom_date">
            <label for="BookingBookedDeptDate">{{ $t("Date to") }}</label>
            <select
                @change="clearAccommodations"
                :disabled="departureDates.length == 0"
                v-model="selectedDepartureDate"
                class="selectBoxIt inputbtn btndefault btnblock styled-select"
                id="BookingBookedDeptDate"
            >
                <option value="">{{ $t("Select a departure date") }}</option>
                <option
                    v-for="date2 in departureDates"
                    :key="date2"
                    :value="date2"
                >
                    {{ $t(weekDay(date2)) }}, {{ ISO2Uk(date2) }}
                </option>
            </select>
        </div>
        <div class="accom_btn">
            <label style="display:block; opacity:0">{{
                $t("Check Accommodation")
            }}</label>
            <button
                href="#"
                class="button blue"
                id="check_availability"
                :disabled="!showCheckAvailabilityButton"
                :class="{ isDisabled: !showCheckAvailabilityButton }"
                v2-if="showCheckAvailabilityButton"
                @click.prevent="getAccommodation"
            >
                {{ $t("Check Accommodation") }}
            </button>
        </div>
    </div>

    <h3 v-if="arrivalDateHint">{{ $t("start of") }} {{ arrivalDateHint }}</h3>

    <div id="results" v-if="!injectedBookingArrivalDate">
        <table
            v-if="getLoadedAvailability"
            class="table"
            border="0"
            cellpadding="0"
            cellspacing="2"
        >
            <tr>
                <th>{{ $t("Accommodation") }}</th>
                <th style="text-align: center;">{{ $t("Sleeps") }}</th>
                <th class="hidden-xs">{{ $t("Availability") }}</th>
                <th>{{ $t("Price") }}</th>
                <th>&nbsp;</th>
            </tr>

            <tbody
                v-for="(accomTypeList,
                accomTypeName,
                index) in getLoadedAvailability"
                :key="index"
            >
                <tr class="heding">
                    <td colspan="4">
                        {{ accomTypeName }}
                    </td>
                </tr>

                <tr
                    v-for="(value, accomID, index) in accomTypeList"
                    :key="index"
                    :class="{ active: accomMatches(value.isByo, accomID) }"
                >
                    <td>
                        <strong>{{ value.accommodation }}</strong>
                    </td>
                    <td style="text-align: center;">{{ value.space }}</td>
                    <td>{{ value.availability }}</td>
                    <td>
                        <span v-if="value.canBook == 'true'"
                            >{{ getCurrency.symbol }}{{ value.price }}
                        </span>
                    </td>
                    <td style="text-align:center">
                        <a
                            class="button blue btn-sm"
                            v-if="value.canBook == 'true'"
                            @click.prevent="
                                setAccommodationType(
                                    extractId(accomID),
                                    value.isByo,
                                    value.price,
                                    value.accommodation,
                                    value.drg,
                                    value.altPrice
                                )
                            "
                            href="#"
                            >{{ $t("Book now") }}</a
                        >
                        <a
                            class="button blue btn-sm"
                            v-if="value.canBook == 'false'"
                            href="mailto:info@springharvestholidays.com"
                            >{{ $t("Contact us") }}</a
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
// import loadedAvailability from "./../availability.json";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
    name: "DateAccommodationCheck",
    watch: {
        selectedArrivalDate: function() {
            // Clear previously selected values
            this.departureDates = [];
            this.selectedDepartureDate = "";
            // Populate list of selected Departure Dates in the second dropdown
            if (this.selectedArrivalDate.length > 0) {
                this.departureDates = this.getLoadedDates[
                    this.selectedArrivalDate
                ].departure_dates;
            }
        }
    },
    data() {
        return {
            injectedBookingArrivalDate: null,
            injectedBookingDepartureDate: null,
            injectedBookingAccTypeId: null,
            injectedBookingLang: null,
            selectedArrivalDate: "",
            selectedDepartureDate: "",
            departureDates: [],
            shouldWatch: true,
            ajaxLoading: false
        };
    },
    computed: {
        ...mapGetters([
            "getLoadedDates",
            "getCurrency",
            "getLoadedAvailability",
            "getBookingDetails"
        ]),
        arrivalDateHint() {
            const propName = this.selectedArrivalDate; //+'2020-05-23'
            return this.selectedArrivalDate == ""
                ? ""
                : this.getLoadedDates[propName].description; //.'a'
        },
        showCheckAvailabilityButton() {
            return (
                this.selectedArrivalDate != "" &&
                this.selectedDepartureDate != ""
            );
        }
    },
    methods: {
        extractId(accomID) {
            let parts = accomID.split("-");
            return parts[1];
        },
        weekDay(day) {
            const weekday = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ];
            const d = new Date(day);
            return weekday[d.getDay()];
        },
        removeInjected() {
            this.selectedArrivalDate = this.injectedBookingArrivalDate;
            this.selectedDepartureDate = this.injectedBookingDepartureDate;
            this.injectedBookingArrivalDate = null;
            this.injectedBookingDepartureDate = null;
            this.injectedBookingAccTypeId = null;
            this.injectedBookingLang = null;
            this.clearAccommodations();
        },
        ISO2Uk(d) {
            return (
                d.split("-")[2] + "/" + d.split("-")[1] + "/" + d.split("-")[0]
            );
        },
        accomMatches(isByo, accomID) {
            if (isByo == "true") {
                return accomID == this.getBookingDetails.ByoTypeID;
            } else {
                return accomID == this.getBookingDetails.AccomTypeID;
            }
        },
        clearAccommodations() {
            this.$store.commit("UPDATE_AVAILABILITY", null);
            this.$store.commit("UPDATE_ACCOMMODATION_DETAILS", {
                BookedArrivalDate: null,
                BookedDeptDate: null,
                AccomTypeID: null,
                ByoTypeID: null,
                PriceTypeID: null,
                Price: null,
                accommodation: null,
                accommodationPrice: 0,
                altAccommodationPrice: 0
            });
            this.$store.commit("CHANGE_PROGRESS_STEP", 0);
        },
        getAccommodation() {
            console.log(
                "this.getCurrency.PriceTypeID",
                this.getCurrency.PriceTypeID
            );
            if (this.injectedBookingArrivalDate != "") {
                var postOptions = {
                    d1: this.injectedBookingArrivalDate,
                    d2: this.injectedBookingDepartureDate,
                    pt: this.getCurrency.PriceTypeID,
                    bid: this.getBookingDetails.bookingId,
                    lang: this.$i18n.locale || "en"
                };
            } else {
                var postOptions = {
                    d1: this.selectedArrivalDate,
                    d2: this.selectedDepartureDate,
                    pt: this.getCurrency.PriceTypeID,
                    bid: this.getBookingDetails.bookingId,
                    lang: this.$i18n.locale || "en"
                };
            }
            this.ajaxLoading = true;
            axios
                .post(
                    process.env.VUE_APP_ROOT_URL + `booking/get-available`,
                    postOptions
                )
                .then(response => {
                    this.ajaxLoading = false;
                    // JSON responses are automatically parsed.
                    console.log(response.data);
                    if (response.data) {
                        // console.log(response.data.response.customer);
                        this.$store.commit(
                            "UPDATE_AVAILABILITY",
                            response.data
                        );

                        // this.showSearch=false;
                        // this.enterDetails=true;

                        // this.disableImportantDataChanges=true;
                    } else {
                        // this.resetFields();
                    }
                })
                .catch(e => {
                    // this.errors.push(e);
                    console.log(e);
                    this.ajaxLoading = false;
                });
        },
        setAccommodationType(
            accId,
            isByo,
            price,
            accommodation,
            drg,
            altPrice
        ) {
            if (this.injectedBookingArrivalDate) {
                var d1 = this.injectedBookingArrivalDate;
                var d2 = this.injectedBookingDepartureDate;
            } else {
                var d1 = this.selectedArrivalDate;
                var d2 = this.selectedDepartureDate;
            }
            this.$store.commit("UPDATE_ACCOMMODATION_DETAILS", {
                BookedArrivalDate: d1,
                BookedDeptDate: d2,
                AccomTypeID: isByo == "true" ? null : accId,
                ByoTypeID: isByo == "true" ? accId : null,
                //TODO: ovde treba da se stavi vo zavisnost od odgran jazik
                PriceTypeID: null,
                accommodationPrice: price,
                altAccommodationPrice: altPrice,
                accommodation: accommodation,
                drg: drg
            });
            this.$store.commit("CHANGE_PROGRESS_STEP", 1);
            this.$router.push({ name: "Extras", hash: "#appTop" });
        }
    },
    created() {
        // console.log(';date created');
        this.shouldWatch = false;
        if (this.getBookingDetails.BookedArrivalDate)
            this.selectedArrivalDate = this.getBookingDetails.BookedArrivalDate;
        if (this.getBookingDetails.BookedDeptDate)
            this.selectedDepartureDate = this.getBookingDetails.BookedDeptDate;
        this.shouldWatch = true;

        // console.log('bookingArrivalDateToInject',bookingArrivalDateToInject);
        this.injectedBookingArrivalDate = bookingArrivalDateToInject;
        this.injectedBookingDepartureDate = bookingDepartureDateToInject;
        this.injectedBookingAccTypeId = bookingAccTypeIdToInject;
        this.injectedBookingLang = bookingLangToInject;
        // this.$store.commit('UPDATE_CURRENCY',bookingCurToInject);
        // console.log('bookingArrivalDateToInject',bookingArrivalDateToInject);
        // console.log('this.selectedDepartureDate',this.selectedDepartureDate);
        if (
            bookingArrivalDateToInject != "" ||
            this.selectedDepartureDate != ""
        ) {
            this.getAccommodation();
        }
        bookingArrivalDateToInject = "";
        this.$i18n.locale = bookingLangToInject || this.$i18n.locale || "en";
    }
};
</script>
<style scoped></style>
